import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

import { ICard } from './types';

const Container = Pressable.withConfig({
  backgroundColor: primitive.$white,
  shadow: '1',
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8,
  borderBottomLeftRadius: 8,
  paddingY: {
    base: '$2',
    md: '$3',
  },
  paddingX: {
    base: '$3',
    md: '$4',
  },
  _web: {
    cursor: 'pointer',
  },
  _hover: {
    shadow: '3',
  },
  margin: 1,
});

type ImageContainerProps = BoxProps & {
  imageHeightWidthRatio: number;
};

const ImageContainer = ({ imageHeightWidthRatio, style, ...props }: ImageContainerProps) => (
  <Box
    {...props}
    style={[styles.imageContainer, { aspectRatio: 1 / imageHeightWidthRatio }, style]}
  />
);

const Content = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.content, style]} />
);

export const Card: React.FC<React.PropsWithChildren<ICard>> = ({
  image,
  children,
  imageHeightWidthRatio = 0.75,
  onPress,
  size,
}) => {
  return (
    <Container onPress={onPress} width={size}>
      <ImageContainer imageHeightWidthRatio={imageHeightWidthRatio}>
        <Picture image={image} height="full" w="100%" alt={''} objectFitContain />
      </ImageContainer>
      <Content>{children}</Content>
    </Container>
  );
};

export default React.memo(Card);

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
  imageContainer: {
    alignSelf: 'center',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    height: spacing.$32,
    width: '100%',
  },
});
